import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "md:pl-96 h-screen",
  style: {"padding-top":"4.5rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_dashboard_layout = _resolveComponent("dashboard-layout")!

  return (_openBlock(), _createBlock(_component_dashboard_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_TheSidebar),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_router_view)
      ])
    ]),
    _: 1
  }))
}